import { printRequest } from "@/axios/autoPrint";
import { get } from "@/axios";


export const getMacAddress = function (params) {
  return printRequest('/print/getMainboardCode','get', params)
}

export const getPrinterList = function (params) {
  return printRequest('/print/getPrintService','get', params)
}

export const autoPrintPdf = function (params) {
  return printRequest('/print/printPdf','post', params)
}

export const autoPrintHtml = function (params) {
  return printRequest('/print/printHtml','post', params)
}

//获取打印机配置
export const getPrintConfig = function(params){
  return get('/wms/logisticsApiConfig/getPrintConfig',params)
}

//获取面单设置
export const getByLogistic = function(params){
  return get('/wms/printConfig/getByLogisticId',params)
}

//获取默认标签配置
export const getDefaultLabelConfig = function(params){
  return get('/wms/defaultLabelConfig/getDefaultLabelConfig',params)
}

//获取批次水洗标配置
export const getPkgPrintConfig = function(params){
  return get('/wms/printConfig/getPrintConfig',params)
}


